import { Image } from '../image';
import type { AwardProps } from './types';
import './styles.css';

/**
 * The Award component is responsible for rendering an individual award item.
 * It accepts props that define the award's attributes, excluding certain fields
 * like 'transformerType' and 'richText' from the AwardNode type.
 *
 * Props:
 * - image: The image associated with the award, passed down from AwardProps.
 *
 * This component utilizes the Image component to display the award's image
 * and applies styling from the 'award' CSS class.
 */
export function Award(props: AwardProps) {
  const { image } = props;

  return (
    <li className="award">
      <Image image={image} {...props} />
    </li>
  );
}
